/*
 * @Author: v_wangmengjiang
 * @Date: 2026-06-08 13:42:28
 * @LastEditors: v_wangmengjiang
 * @LastEditTime: 2026-06-08 13:51:10
 * @Description:
 */
import React from "react";
import styles from "./index.module.less";

/**
 * 拖拽上传遮罩层
 * 当用户拖拽图片到页面时展示
 */
const DragOverlay: React.FC = () => {
    return (
        <div className={styles.dragOverlay}>
            <div className={styles.dragContent}>
                <div className={styles.dragIcon}>
                    <img
                        src="https://med-fe.cdn.bcebos.com/fe-doctor-workbench/%E5%9B%BE%E7%89%87bg.png"
                        alt=""
                        width={108}
                        height={84}
                    />
                </div>
                <p className={styles.dragTitle}>在此处拖放图片，松手完成上传</p>
                <p className={styles.dragDesc}>支持jpg、png、jpeg，最多5张，最大10MB</p>
            </div>
        </div>
    );
};

export default DragOverlay;
